import React from "react";
import CorporateHomeBanner from "./CorporateHomeBanner";
import CorporateHomeIntro from "./CorporateHomeIntro";
import CorporateInfoCardListing from "./CorporateInfoCardListing";
import CorporateHomeSustain from "./CorporateHomeSustain";
import CorporateBottomCardListing from "./CorporateBottomCardListing";

function CorporateHome() {
    return (
        <>
        <div>
            <CorporateHomeBanner/>
            <CorporateHomeIntro/>
            <CorporateInfoCardListing/>
            <CorporateHomeSustain/>
            <CorporateBottomCardListing/>
        </div>
        </>
    )
}

export default CorporateHome;